import api from 'api';

export const NOTIFICATION_QUOTE_URL =
  'pricing/notifications/shipper_app_quote/';
export const SUBMIT_ORDER_URL = 'shipper-app/shipper_orders/';
export const SUBMIT_RECURRING_ORDER_URL = 'recurring_orders/';
export const GET_HOLIDAYS = 'holidays/';

export const getNotificationQuoteService = ({ shipmentsInForm, extras }) => {
  return [
    api.post,
    NOTIFICATION_QUOTE_URL,
    {
      shipments: Object.values(shipmentsInForm),
      extras,
    },
  ];
};

export const getHolidaysService = ({ body }) => {
  return [api.authPost, GET_HOLIDAYS, body];
};

export const getSubmitService = ({ isRecurring, body }) => {
  if (isRecurring) {
    return [api.post, SUBMIT_RECURRING_ORDER_URL, body];
  }
  return [api.post, SUBMIT_ORDER_URL, body];
};
